import React, {PropsWithChildren} from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {ORBIT_TAP} from '../../themes/css-global-classes';


interface TapHandlerProps extends PropsWithChildren {
  enabled: boolean;
  elementRef: any;
}

export class TapHandlerLogic {
    constructor(private _element: HTMLElement) {
      /**
       * No need to check device.feature.isTouch because on PC touchstart will not trigger
       * And mouseup will trigger afer any
       */
      this._element.addEventListener('touchstart', this._onMouseDownHandler);
      this._element.addEventListener('mousedown', this._onMouseDownHandler);
      this._element.addEventListener('touchend', this._onMouseUpHandler);
      this._element.addEventListener('touchcancel', this._onMouseUpHandler);
      this._element.addEventListener('mouseup', this._onMouseUpHandler);
    }

    private _onMouseDownHandler = () => {
      this._element.classList.add(ORBIT_TAP);
    }
    private _onMouseUpHandler = () => {
      this._element.classList.remove(ORBIT_TAP);
    }
    
    dispose() {
      this._element.removeEventListener('touchstart', this._onMouseDownHandler);
      this._element.removeEventListener('mousedown', this._onMouseDownHandler);
      this._element.removeEventListener('touchend', this._onMouseUpHandler);
      this._element.removeEventListener('touchcancel', this._onMouseUpHandler);
      this._element.removeEventListener('mouseup', this._onMouseUpHandler);
    }

}


export class TapHandler extends OrbitComponent<TapHandlerProps> {


  render() {
    return (
        <>
          {this.props.children}
        </>
    )
  }


  private _tapHandlerLogic: TapHandlerLogic | null = null;

  componentDidMount() {
    super.componentDidMount();
    if(this.props.enabled) {
      this._tapHandlerLogic = new TapHandlerLogic(this.props.elementRef.current);
    }

  }

  componentWillUnmount() {
    super.componentWillUnmount();
    if(this._tapHandlerLogic) {
        this._tapHandlerLogic.dispose();
    }
  }


}
